/**
 * Iconos de línea del rediseño (SVGs del prototipo "Frescazo App").
 * Todos aceptan `size` y heredan el color vía `stroke`/`fill` explícitos.
 */

interface IconoProps {
  size?: number;
  color?: string;
  strokeWidth?: number;
  className?: string;
}

export function IconoCarrito({ size = 15, color = "currentColor", strokeWidth = 2, className }: IconoProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" className={className}>
      <path d="M6 8h12l-1 12H7L6 8z" />
      <path d="M9 8V6a3 3 0 0 1 6 0v2" />
    </svg>
  );
}

export function IconoAtras({ size = 18, color = "currentColor", strokeWidth = 2.4, className }: IconoProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M15 5l-7 7 7 7" />
    </svg>
  );
}

export function IconoMenu({ size = 17, color = "currentColor", strokeWidth = 2, className }: IconoProps) {
  return (
    <svg width={size} height={size * (14 / 17)} viewBox="0 0 17 14" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" className={className}>
      <path d="M1 2h15M1 7h15M1 12h15" />
    </svg>
  );
}

export function IconoCasa({ size = 17, color = "currentColor", strokeWidth = 2, className }: IconoProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M3 10.5L12 3l9 7.5" />
      <path d="M5.5 9.5V21h13V9.5" />
    </svg>
  );
}

/** Botella/boot de la barra inferior (pestaña Productos). */
export function IconoBoot({ size = 12, color = "currentColor", strokeWidth = 1.5, className }: IconoProps) {
  return (
    <svg width={size} height={size * (17 / 12)} viewBox="0 0 12 17" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinejoin="round" className={className}>
      <path d="M4.4 1h3.2v2.1l2.4 2.6v9.5a.9.9 0 0 1-.9.8H2.9a.9.9 0 0 1-.9-.8V5.7l2.4-2.6V1z" />
      <path d="M2 9h8" />
    </svg>
  );
}

/** Chispas de Pepa (pestaña "A mi medida"). */
export function IconoChispa({ size = 17, color = "currentColor", strokeWidth = 1.9, className }: IconoProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M12 3l1.8 4.7L18.5 9.5 13.8 11.3 12 16l-1.8-4.7L5.5 9.5l4.7-1.8L12 3z" />
      <path d="M18 16.5l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8.8-2z" />
    </svg>
  );
}

export function IconoLupa({ size = 17, color = "currentColor", strokeWidth = 2.2, className }: IconoProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" className={className}>
      <circle cx="11" cy="11" r="7" />
      <path d="M16.5 16.5L21 21" />
    </svg>
  );
}

export function IconoCorazon({
  size = 14,
  color = "currentColor",
  strokeWidth = 1.8,
  relleno = "none",
  className,
}: IconoProps & { relleno?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={relleno} stroke={color} strokeWidth={strokeWidth} className={className}>
      <path d="M12 20s-7-4.6-7-9.3A4 4 0 0 1 12 8a4 4 0 0 1 7 2.7C19 15.4 12 20 12 20z" />
    </svg>
  );
}

export function IconoCheck({ size = 20, color = "currentColor", strokeWidth = 2.6, className }: IconoProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M5 13l4.5 4.5L19 7" />
    </svg>
  );
}

export function IconoMas({ size = 14, color = "currentColor", strokeWidth = 2.6, className }: IconoProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" className={className}>
      <path d="M12 5v14M5 12h14" />
    </svg>
  );
}

/** Logo de WhatsApp (relleno). */
export function IconoWhatsApp({ size = 20, color = "currentColor", className }: IconoProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color} className={className}>
      <path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm4.7 13.4c-.2.6-1.2 1.2-1.7 1.2-1.4.1-3.3-1-4.8-2.4-1.4-1.4-2.6-3.3-2.5-4.7 0-.5.6-1.5 1.2-1.7.3-.1.7 0 .9.4l.8 1.5c.1.3.1.5-.1.8l-.4.5c-.2.2-.2.4-.1.6.3.6 1.5 1.8 2.1 2.1.2.1.4.1.6-.1l.5-.4c.2-.2.5-.3.8-.1l1.5.8c.4.2.5.6.4 1z" />
    </svg>
  );
}

export function IconoSubir({ size = 20, color = "currentColor", strokeWidth = 2, className }: IconoProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M12 17V5" />
      <path d="M7 10l5-5 5 5" />
      <path d="M4 19h16" />
    </svg>
  );
}

export function IconoCamara({ size = 20, color = "currentColor", strokeWidth = 2, className }: IconoProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className}>
      <rect x="3" y="6" width="18" height="13" rx="3" />
      <circle cx="12" cy="12.5" r="3" />
    </svg>
  );
}

export function IconoReloj({ size = 42, color = "currentColor", strokeWidth = 1.9, className }: IconoProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" className={className}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3.5 2" />
    </svg>
  );
}

/** Pin de mapa con X (fuera de cobertura). */
export function IconoPinX({ size = 34, color = "currentColor", strokeWidth = 1.8, className }: IconoProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" className={className}>
      <path d="M12 21s7-6.3 7-11a7 7 0 1 0-14 0c0 4.7 7 11 7 11z" />
      <path d="M9.5 9.5l5 5M14.5 9.5l-5 5" />
    </svg>
  );
}

export function IconoCalendario({ size = 40, color = "currentColor", strokeWidth = 1.7, className }: IconoProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className}>
      <rect x="4" y="5" width="16" height="15" rx="3" />
      <path d="M8 3v4M16 3v4M8 12h8M8 16h5" />
    </svg>
  );
}

export function IconoLapiz({ size = 14, color = "currentColor", strokeWidth = 2.2, className }: IconoProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" className={className}>
      <path d="M4 20h4l10-10-4-4L4 16v4z" />
    </svg>
  );
}

export function IconoCopiar({ size = 16, color = "currentColor", strokeWidth = 2, className }: IconoProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinejoin="round" className={className}>
      <rect x="9" y="9" width="11" height="11" rx="2" />
      <path d="M15 5H6a2 2 0 0 0-2 2v9" />
    </svg>
  );
}
